import { IAction } from '~/src/store';
import { EAction } from '~/src/store/actionTypes/agreements';
import { TAgreement, TAgreements } from '~/src/store/reducers/agreements';

export const setAgreements = (agreements: TAgreement[]): IAction<EAction.SetAgreements, {
    agreements: TAgreements,
}> => ({
    type: EAction.SetAgreements,
    payload: {
        agreements,
    },
});
